import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import _flatten from "lodash/flatten";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import { MenuItem, SideNav, NavBar, NavigationProvider, useUser } from 'components';
import { PrivateRoutes } from '../Private/PrivateRoutes';
import { PublicRoutes } from '../Public/PublicRoutes';
import { CreditsList } from '../Private/Credits';
import CreditCalculator from '../Private/CreditCalculator';
import { BorrowersList } from '../Private/Borrowers';
import { EmployeeList } from '../Private/Employee';
import { ExternalCreditList } from '../Private/ExternalCredit';
import { OfficeList } from '../Private/Office';
import { ActionList } from '../Private/Actions';
import { TotalGivenAmountPage, TotalFuturePaymentsPage, ExpectedPrincipalPage, CurrentMonthPage, PastPrincipalPage, CollectedPaymentsPage, AllPaymentsPage } from '../Private/GivenPayments';
import AvailableFunds from '../Private/AvailableFunds';
import ContractsReference from '../Private/ContractsReference';
import { AccountingReferencePage, IssuedCreditsPage, DueInterestPage, PayedByMonthPage, HomeVisitFeePage, PrincipalsByMonthPage, PaymentsReferencePage, PaymentsByMonthPerCreditPage } from '../Private/Accounting';
import Receivables from '../Private/Receivables';
import LatePayments from '../Private/LatePayments';
import InterestFeesReference from '../Private/InterestFeesReference';
import InterestsFeesReportRequest from '../Private/InterestsFeesReportRequest';
import CommissionReportRequest from '../Private/CommissionReportRequest';
import { FranchisesList } from '../Private/Franchises';
import ExportRelif from '../Private/ExportRelif';
import ExportAnaCredit from '../Private/ExportAnaCredit';
import NotFound from '../Public/NotFound';
import PartnerList from '../Private/Partners/PartnerList';
import { PaymentsList } from '../Private/Payments';
import { PartnerCashDeskSummary, PartnerCashDeskEmployeeBalance } from '../Private/PartnerCashDesk';
import { Dashboard } from '../Private/Dashboard';
import { PartnerCommissionReports } from '../Private/PartnerCommissionReports';
import { jsx as ___EmotionJSX } from "@emotion/react";

var App = function App() {
  var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated,
      roleAdditionalData = _useUser.roleAdditionalData;

  return ___EmotionJSX(NavigationProvider, null, isAuthenticated ? ___EmotionJSX(SideNav, {
    homeRoute: "/dashboard",
    routes: _flatten(Object.values(PrivateRoutes(roleAdditionalData)).map(function (el) {
      return el.internal;
    })),
    notFoundComponent: NotFound,
    topNavigation: NavBar
  }, ___EmotionJSX(MenuItem, {
    url: "/dashboard",
    label: "\u0414\u0430\u0448\u0431\u043E\u0440\u0434",
    icon: "las la-tachometer-alt",
    component: Dashboard
  }), (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isAdminOrTenantOrOwnerOrManager) && ___EmotionJSX(MenuItem, {
    url: "/actions",
    label: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
    icon: "las la-tasks",
    component: ActionList
  }), ___EmotionJSX(MenuItem, {
    url: "/credits",
    label: "\u041A\u0440\u0435\u0434\u0438\u0442\u0438",
    icon: "las la-credit-card",
    subMenus: [{
      url: '/credits',
      label: 'Кредити',
      component: CreditsList
    }, {
      url: '/credits-calculator',
      label: 'Кредитен калкулатор',
      component: CreditCalculator
    }, {
      url: '/borrowers',
      label: 'Кредитополучатели',
      component: BorrowersList
    }].concat(_toConsumableArray(roleAdditionalData !== null && roleAdditionalData !== void 0 && roleAdditionalData.isAdminOrTenantOrOwnerOrManager ? [{
      url: '/contract-reference',
      label: 'Договори',
      component: ContractsReference
    }] : []), _toConsumableArray(roleAdditionalData !== null && roleAdditionalData !== void 0 && roleAdditionalData.isAdminOrTenantOrOwnerOrManager ? [{
      url: '/receivables',
      label: 'Вземания',
      component: Receivables
    }] : []), _toConsumableArray(roleAdditionalData !== null && roleAdditionalData !== void 0 && roleAdditionalData.isAdminOrTenantOrOwnerOrManager ? [{
      url: '/interest-and-fees',
      label: 'Лихви',
      component: InterestFeesReference
    }] : []), _toConsumableArray(roleAdditionalData !== null && roleAdditionalData !== void 0 && roleAdditionalData.isAdminOrTenantOrOwnerOrManager ? [{
      url: '/late-payments',
      label: 'Просрочия',
      component: LatePayments
    }] : []), [{
      url: '/payments',
      label: 'Плащания',
      component: PaymentsList
    }])
  }), (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isAdminOrTenantOrOwnerOrManager) && ___EmotionJSX(MenuItem, {
    url: "/given-payments",
    label: "\u0421\u043F\u0440\u0430\u0432\u043A\u0438",
    icon: "las la-chart-bar",
    subMenus: [{
      url: '/given-payments',
      label: 'Раздадени средства',
      subMenus: [{
        url: '/given-payments/all-payments-breakdown',
        label: 'Обща информация кредити',
        component: AllPaymentsPage
      }, {
        url: '/given-payments/total-given-credit-amount',
        label: 'Раздадени кредити',
        component: TotalGivenAmountPage
      }, {
        url: '/given-payments/total-future-payments-amount',
        label: 'Непадежирали главници',
        component: TotalFuturePaymentsPage
      }, {
        url: '/given-payments/expected-principal-by-week',
        label: 'Очаквани средства',
        component: ExpectedPrincipalPage
      }, {
        url: '/given-payments/current-month-reference',
        label: 'Средства за месеца',
        component: CurrentMonthPage
      }, {
        url: '/given-payments/past-principal-by-month',
        label: 'Средства минал период',
        component: PastPrincipalPage
      }, {
        url: '/given-payments/collected-payments-breakdown',
        label: 'Приключили кредити',
        component: CollectedPaymentsPage
      }]
    }, {
      url: '/available-funds',
      label: 'Налични средства',
      component: AvailableFunds
    }].concat(_toConsumableArray(roleAdditionalData !== null && roleAdditionalData !== void 0 && roleAdditionalData.isAdminOrTenant ? [{
      url: '/accounting-reference',
      label: 'Счетоводство',
      subMenus: [{
        url: '/accounting-reference/accounting',
        label: 'Счетоводство',
        component: AccountingReferencePage
      }, {
        url: '/accounting-reference/issued-credits',
        label: 'Кредити в момента на отпускането',
        component: IssuedCreditsPage
      }, {
        url: '/accounting-reference/due-interest',
        label: 'Падежирали лихви',
        component: DueInterestPage
      }, {
        url: '/accounting-reference/payed-by-month',
        label: 'Платени',
        component: PayedByMonthPage
      }, {
        url: '/accounting-reference/home-visit-fee',
        label: 'Такса домашно посещение',
        component: HomeVisitFeePage
      }, {
        url: '/accounting-reference/principals-by-month',
        label: 'Отпуснати кредити по месеци',
        component: PrincipalsByMonthPage
      }, {
        url: '/accounting-reference/payments',
        label: 'Детайли за плащания',
        component: PaymentsReferencePage
      }, {
        url: '/accounting-reference/payments-by-month',
        label: 'Плащания по кредити и по месеци',
        component: PaymentsByMonthPerCreditPage
      }]
    }] : []))
  }), (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isAdminOrTenant) && ___EmotionJSX(MenuItem, {
    url: "/relif-export",
    label: "\u0411\u041D\u0411",
    icon: "las la-university",
    subMenus: [{
      url: '/relif-export',
      label: 'Експорт РеЛИФ',
      component: ExportRelif
    }, {
      url: '/relif-ana-credit',
      label: 'Експорт АнаКредит',
      component: ExportAnaCredit
    }]
  }), (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isAdminOrTenantOrOwnerOrManager) && ___EmotionJSX(MenuItem, {
    url: "/interests-and-fees-report-request",
    label: "\u041E\u0442\u0447\u0435\u0442\u0438",
    icon: "las la-clipboard-list",
    subMenus: [{
      url: '/interests-and-fees-report-request',
      label: 'Лихви и такси',
      component: InterestsFeesReportRequest
    }].concat(_toConsumableArray(roleAdditionalData !== null && roleAdditionalData !== void 0 && roleAdditionalData.isAdminOrTenantOrOwner ? [{
      url: '/commission-report-request',
      label: 'Комисионни',
      component: CommissionReportRequest
    }] : []), _toConsumableArray(roleAdditionalData !== null && roleAdditionalData !== void 0 && roleAdditionalData.isPartnerOrPartnerManager || roleAdditionalData !== null && roleAdditionalData !== void 0 && roleAdditionalData.isAdminOrTenant ? [{
      url: '/partner-commission-reports',
      label: 'Домашно посещение',
      component: PartnerCommissionReports
    }] : []))
  }), ((roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isPartnerOrPartnerManager) || (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isAdminOrTenant)) && ___EmotionJSX(MenuItem, {
    url: "/partner-cash-desk",
    label: "\u041F\u0430\u0440\u0442\u043D\u044C\u043E\u0440\u0438",
    icon: "las la-handshake",
    subMenus: [{
      url: '/partner-cash-desk',
      label: 'Партньорска каса',
      subMenus: [{
        url: '/partner-cash-desk/cash-desk',
        label: 'Каса',
        component: PartnerCashDeskSummary
      }].concat(_toConsumableArray(roleAdditionalData !== null && roleAdditionalData !== void 0 && roleAdditionalData.isPartnerManager || roleAdditionalData !== null && roleAdditionalData !== void 0 && roleAdditionalData.isAdminOrTenant ? [{
        url: '/partner-cash-desk/employee-balance',
        label: 'Баланс служители',
        component: PartnerCashDeskEmployeeBalance
      }] : []))
    }].concat(_toConsumableArray(roleAdditionalData !== null && roleAdditionalData !== void 0 && roleAdditionalData.isAdminOrTenant ? [{
      url: '/franchises',
      label: 'Кредитни посредници',
      component: FranchisesList
    }] : []), _toConsumableArray(roleAdditionalData !== null && roleAdditionalData !== void 0 && roleAdditionalData.isAdminOrTenant ? [{
      url: '/partner',
      label: 'Партньори',
      component: PartnerList
    }] : []))
  }), (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isAdminOrTenant) && ___EmotionJSX(MenuItem, {
    url: "/employee",
    label: "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F",
    icon: "las la-cog",
    subMenus: [{
      url: '/employee',
      label: 'Служители',
      component: EmployeeList
    }].concat(_toConsumableArray(roleAdditionalData !== null && roleAdditionalData !== void 0 && roleAdditionalData.isAdminOrTenantOrOwnerOrManager ? [{
      url: '/office',
      label: 'Офиси',
      component: OfficeList
    }] : []))
  }), (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isAdminOrTenant) && ___EmotionJSX(MenuItem, {
    url: "/external-credit",
    label: "\u0412\u044A\u043D\u0448\u043D\u0438 \u043A\u0440\u0435\u0434\u0438\u0442\u0438",
    icon: "las la-file-invoice-dollar",
    component: ExternalCreditList
  })) : ___EmotionJSX(PublicRoutes, null));
};

export default App;